
import { 
  fetchJson,
  UPDATE_ANONYMOUS_USER_EMAIL,
  UPDATE_ANONYMOUS_USER_EMAIL_ASYNC,
  REMOVE_ANONYMOUS_USER_EMAIL,
  REMOVE_ANONYMOUS_USER_EMAIL_ASYNC
} from '../../GlobalStateContainer'

import {
  notifyError
} from '../UserMessaging'

const onUpdateAnonymousUserEmailSuccess = (responseObject, anonymousUserEmailRequest) => {
    const anonymousUserEmail = anonymousUserEmailRequest.AnonymousUserEmail;
    if(responseObject === "OK") {
    return {type: UPDATE_ANONYMOUS_USER_EMAIL, anonymousUserEmail};
  } else {
    return notifyError("We could not save your email '" + anonymousUserEmail + "'. Please confirm it is valid, and you have typed it correctly.",
    responseObject);
  }
}

const UpdateAnonymousUserEmailSpec = {
  endpoint: (state) => state.constants.navigation.updateAnonymousUserEmailEndpoint,
  fetchInit: { method: 'POST', credentials: 'same-origin' },
  notify: (anonymousUserEmail) => ({type: UPDATE_ANONYMOUS_USER_EMAIL_ASYNC, anonymousUserEmail}),
  extract: (response) => response.text(),
  onSuccess: onUpdateAnonymousUserEmailSuccess,
  onError: (diagMsg) => notifyError("An error occurred updating your email", diagMsg),
}

export const updateAnonymousUserEmailAsync = fetchJson(UpdateAnonymousUserEmailSpec);

const onRemoveAnonymousUserEmailSuccess = (responseObject) => {
  if(responseObject === "OK") {
    return {type: REMOVE_ANONYMOUS_USER_EMAIL};
  } else {
    console.log(responseObject);
  }
}

const RemoveAnonymousUserEmailAsyncSpec = {
  endpoint: (state) => state.constants.navigation.removeAnonymousUserEmailEndpoint,
  fetchInit: { method: 'POST', credentials: 'same-origin' },
  notify: () => ({type: REMOVE_ANONYMOUS_USER_EMAIL_ASYNC}),
  extract: (response) => response.text(),
  onSuccess: onRemoveAnonymousUserEmailSuccess,
  onError: (diagMsg) => notifyError("An error occured clearing your email", diagMsg),
}

export const removeAnonymousUserEmailAsync = fetchJson(RemoveAnonymousUserEmailAsyncSpec);


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/AnonymousUserEmail/anonymousUserEmailActions.js